export function concatUrl(...items: string[]): string {
  const components: string[] = items.reduce((result: string[], item: string) => {
    if (item) {
      result.push(item);
    }
    return result;
  }, []);
  const url = components
    .map((item: string) => {
      let resultItem = item;
      if (item.endsWith('/')) {
        resultItem = resultItem.slice(0, -1);
      }
      if (item.startsWith('/')) {
        resultItem = resultItem.substring(1);
      }
      return resultItem;
    })
    .join('/');
  if (components.length > 0 && components[0] !== '' && components[0].startsWith('/')) {
    return '/' + url;
  }
  return url;
}
